import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function useNavigation() {
  const nav = useRouter();
  const currentPathname = usePathname();
  const [navigating, setNavigating] = useState(false);
  const [newPathname, setNewPathname] = useState(currentPathname);

  function push(path: string) {
    nav.push(path);
    setNewPathname(path);
    setNavigating(true);
  }

  useEffect(() => {
    if (navigating && currentPathname == newPathname) {
      setNavigating(false); 
    }
  }, [currentPathname, navigating, newPathname]);

  return {
    push,
    navigating,
    setNewPathname,
  }
}
